import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  const logout = () => {
    localStorage.removeItem('authToken');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const savedToken = localStorage.getItem('authToken');
    if (!savedToken) return;

    try {
      const decodedUser = jwtDecode(savedToken);
      setToken(savedToken);
      setUser(decodedUser);
      setIsAuthenticated(true);
    } catch (error) {
      console.error('Erro ao decodificar o token do localStorage:', error);
      logout();
    }
  }, []);

  const login = (nextToken) => {
    if (!nextToken || typeof nextToken !== 'string') {
      console.error('Token inválido recebido:', nextToken);
      return false;
    }

    try {
      const decodedUser = jwtDecode(nextToken);
      localStorage.setItem('authToken', nextToken);
      setToken(nextToken);
      setUser(decodedUser);
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      logout();
      return false;
    }
  };

  const value = useMemo(
    () => ({ isAuthenticated, user, token, login, logout }),
    [isAuthenticated, user, token]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
